import React from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { formatearNumero, isValidParam} from '../../../../common/Formatos'

const SolicitudEnProceso = () => {
    const data_solicitud_modal = useSelector(
        (state) => state.modalCartaCiaTerceroReducer
      )
      const {solicitudDescuento } =
      data_solicitud_modal
  return (
    <div>
        <Row>
            <Col md='8'>
            <Form.Label
                className='mb-0 mt-3'
                style={{ fontWeight: 'bold', fontSize: '16px' }}
            >
                Existe solicitud de descuento en proceso:
            </Form.Label>{' '}
    </Col>
</Row>
       <Container>
        <Row className='mb-4'>
            <Col md='2'>
            <Form.Label
                className='mb-2 mt-3'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                Fecha Solicitud 
            </Form.Label>{' '}
            <br />
            
                <Form.Text className='mt-3'>{solicitudDescuento &&
                        solicitudDescuento.solicitudDescuento[0][
                          'fecSolDctoFormat'
                        ] !== undefined &&
                        solicitudDescuento.solicitudDescuento[0][
                          'fecSolDctoFormat'
                        ] !== null &&
                        solicitudDescuento.solicitudDescuento[0][
                          'fecSolDctoFormat'
                        ] !== ''
                          ? (solicitudDescuento.solicitudDescuento[0][
                              'fecSolDctoFormat'
                            ])
                          : ''}</Form.Text>
            
    </Col>

            <Col md='2'>
            <Form.Label
                className='mb-2 mt-3'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                % Solicitado
            </Form.Label>{' '}
            <br />
            
                <Form.Text className='mt-3 mx-3'>{solicitudDescuento &&
                        solicitudDescuento.solicitudDescuento[0][
                          'porcPropuestoSolDcto'
                        ] !== undefined &&
                        solicitudDescuento.solicitudDescuento[0][
                          'porcPropuestoSolDcto'
                        ] !== null &&
                        solicitudDescuento.solicitudDescuento[0][
                          'porcPropuestoSolDcto'
                        ] !== ''
                          ? (solicitudDescuento.solicitudDescuento[0][
                              'porcPropuestoSolDcto'
                            ])
                          : ''}</Form.Text>
            
    </Col>
    <Col md='2'>
      <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
          Recobro Solicitado
      </Form.Label>{' '}
      <br />
      <Form.Text className='mt-3'>
        {solicitudDescuento && isValidParam(solicitudDescuento.solicitudDescuento[0]['montoPropuestoSolDcto']) ? 
          formatearNumero(solicitudDescuento.solicitudDescuento[0]['montoPropuestoSolDcto'], 
            !(isValidParam((solicitudDescuento.solicitudDescuento)[0]['idMonedaSolDcto']) && solicitudDescuento.solicitudDescuento[0]['idMonedaSolDcto'] == 30001))                          
          : ''
        }
      </Form.Text>            
    </Col>
            <Col md='4'>
            <Form.Label
                className='mb-2 mt-3'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                Motivo
            </Form.Label>{' '}
            <br />
            
                <Form.Text className='mt-3'>{solicitudDescuento &&
                        solicitudDescuento.solicitudDescuento[0][
                          'motivoSolDcto'
                        ] !== undefined &&
                        solicitudDescuento.solicitudDescuento[0][
                          'motivoSolDcto'
                        ] !== null &&
                        solicitudDescuento.solicitudDescuento[0][
                          'motivoSolDcto'
                        ] !== ''
                          ? (solicitudDescuento.solicitudDescuento[0][
                              'motivoSolDcto'
                            ])
                          : ''}</Form.Text>
            
    </Col>
</Row>
</Container>
        

        
</div>
  )
}

export default SolicitudEnProceso